module.exports = __webpack_public_path__ + "static/img/robot-logo.7bea3ed1.png";